import { render, staticRenderFns } from "./Quotazioni.vue?vue&type=template&id=1eafc9c6"
import script from "./Quotazioni.vue?vue&type=script&lang=js"
export * from "./Quotazioni.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports